import { ReactElement, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { BodyContainer } from "./AuthSite";
import { TranslationService } from "../../services/TranslationService";

export enum Controls {
    newinvoices,
    newCustomers,
    newPayments,
    DebtIncrement,
    DebtDecrement
}

function PageNotFound(): ReactElement {
    const { translate } = TranslationService;
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const errorMessageParam = params.get("msg");
    const errorSubMessage = useMemo(() => {
        switch (errorMessageParam) {
            case 'SessionExpired':
                return 'TokenExpiredMessage';
            case 'ErrorProcessingRequest':
                return 'InvalidTokenMessage';
            default:
                return '';
        }
    }, [errorMessageParam])

    const returnHome = () => window.location.href = "https://www.intiza.com/cobranzas";


    return (
        <div className="old-page">
            <BodyContainer>
                <div className="pt-5">
                    <div className="container" id="signin">
                        <div className="d-flex flex-column fw-normal fs-7 gap-3">
                            <h3>{translate[errorMessageParam as string] || translate['ErrorProcessingRequest']}</h3>
                            <p>{translate[errorSubMessage as string]}</p>
                        </div>
                        <div className="d-flex align-items-center mt-3 gap-3">
                            <button type="button" className="btn btn-primary py-1 "
                                onClick={returnHome}>{TranslationService.translate.GoBack}</button>
                        </div>
                    </div>
                </div>
            </BodyContainer>
        </div>
    );
}

export default PageNotFound;
